export default __webpack_public_path__ + "static/media/696.96bd25dc.png";